/**
 * User events
 */
export const USER_SET_INFO = 'USER_SET_INFO'
export const USER_SET_PERMISSIONS = 'USER_SET_PERMISSIONS'
export const USER_SET_LOGGED_IN = 'USER_SET_LOGGED_IN'
export const RESET_USER_LOGIN = 'RESET_USER_LOGIN'

/**
 * Map Events
 */
export const AUCTION_SET_AUCTIONS = "AUCTIONS_SET_AUCTIONS"
export const AUCTION_SET_LOTS = "AUCTION_SET_LOTS"
export const AUCTION_SET_SHOW = "AUCTION_SET_SHOW"
export const AUCTION_INIT = "AUCTION_INIT"
export const AUCTION_SET_ORDER = "AUCTION_SET_ORDER"
export const AUCTION_RESULTS_SET_ORDER = "AUCTION_RESULTS_SET_ORDER"


/**
* LiveWidget events
**/

export const LIVE_WIDGET_ADD_TO_HISTORY = "LIVE_WIDGET_ADD_TO_HISTORY"
export const LIVE_WIDGET_HISTORY_INIT = "LIVE_WIDGET_HISTORY_INIT"
export const KEEP_HISTORY_ALIVE = "KEEP_HISTORY_ALIVE"
export const LIVE_WIDGET_LOT_PUBLISHED = "LIVE_WIDGET_LOT_PUBLISHED"
